export const formatPackageNumber = (uuid: string): string => {
  const digits = uuid.replace(/\D/g, '');
  if (!digits) {
    return '—';
  }
  return digits.slice(-8).padStart(8, '0');
};

export const formatPackageExternalId = (uuid: string): string => {
  const digits = uuid.replace(/\D/g, '');
  if (!digits) {
    return uuid;
  }
  return digits.slice(0, 11);
};

export const formatProjectExternalId = formatPackageExternalId;

export const formatEntryDate = (isoDate?: string): string => {
  if (!isoDate) {
    return '—';
  }

  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  return date.toLocaleDateString('ru-RU');
};

export const formatRoiIrr = (roi?: number, xirr?: number): string => {
  const roiLabel = roi != null ? `${roi.toFixed(1)}%` : '—';
  const irrLabel = xirr != null ? `${xirr.toFixed(1)}%` : '—';
  return `${roiLabel} / ${irrLabel}`;
};

export const toMoneyAmount = (amount: unknown): number => {
  if (typeof amount === 'number' && Number.isFinite(amount)) {
    return amount;
  }

  if (typeof amount === 'string' && amount !== '') {
    const parsed = Number(amount);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
};

export const sumMoneyAmounts = (
  items: Array<{ amount: number | string; currencyCode?: string }>,
  currencyCode: string
): { amount: number; currencyCode: string } => ({
  amount: items.reduce((sum, item) => sum + toMoneyAmount(item.amount), 0),
  currencyCode,
});

export const weightedAverageByInvested = (
  items: Array<{ invested: { amount: number | string }; value?: number }>
): number | undefined => {
  const valid = items.filter(
    (item) => item.value != null && toMoneyAmount(item.invested.amount) > 0
  );

  if (valid.length === 0) {
    return undefined;
  }

  const totalWeight = valid.reduce((sum, item) => sum + toMoneyAmount(item.invested.amount), 0);

  if (totalWeight === 0) {
    return undefined;
  }

  return (
    valid.reduce((sum, item) => sum + item.value! * toMoneyAmount(item.invested.amount), 0) /
    totalWeight
  );
};
